<template>
    <div class="scroll-hide">
    <div class="privacy">
      <div class="header">
        <!-- <div class="title">第三方共享个人信息清单</div> -->
      </div>
      <div class="content">
        <div class="text">
            为保障{{brand}}APP相关功能的实现和应用的安全稳定运行，我们会接入由第三方提供的软件开发包（SDK）实现该目的。
        </div>
        <div class="text">
            我们会对第三方 SDK进行严格的安全检测，并要求合作伙伴采取严格的措施来保护您的个人数据。在满足新的服务需求及业务功能变更时，我们可能会调整我们接入的第三方 SDK，并及时在本说明中向您公开说明接入第三方 SDK的最新情况。请注意，第三方 SDK可能因为版本升级、策略调整等原因导致数据类型存在一些变化，附其官方网站链接或相关隐私保护说明链接供参考，具体请以其公示的官方说明为准。
        </div>
        <div v-html="thirdSdk"></div>
      </div>
    </div>
    </div>
  </template>

  <script>

  import axios from "axios";

  export default {
    name: 'trilateralPerInfoList',
    data() {
      return {
        brand: '',
        thirdSdk: ''
      }
    },
    async mounted() {
      this.brand = this.$config.env.VUE_APP_BRAND === "COTTI" ? "库迪咖啡" : "茶猫"

      // 通过CDN获取到隐私协议的内容
      try {
        // const response = await axios.get(`https://cotti-common-test.obs.ap-southeast-3.myhuaweicloud.com/privacy.html?v=${new Date().getTime()}`); // 获取协议内容
        const response = await axios.get(`https://cdn-product-prod.yummy.tech/cottiCoffee-api/privacy/third_sdk.html?v=${new Date().getTime()}`);
        this.thirdSdk = response.data;
      } catch (error) {
        console.error('加载隐私协议失败:', error);
      }

    },
    methods: {
    //   childHerf () {
    //     this.$router.push({path: '/childPrivacy'})
    //   }
    }
  }
  </script>

  <style scoped lang="scss">
  .scroll-hide {
    width: 100%;
    height: 100vh;
    -webkit-overflow-scrolling: touch;
    overflow-scrolling: touch;
    overflow-y: scroll;
    position: fixed;
    position: -ms-device-fixed;
    top: 0px; left: 0px; right: 0px; bottom: 0px;
  }
  .privacy{
    padding: 32px;
    font-size: 24px;
    line-height: 40px;
    word-break: break-all;
    background: #F8F8F8;
    .bold{
      font-weight: bold !important;
      .child-herf {
        color: #346EF4;

      }
    }
    .title{
      font-weight: bold !important;
      font-size: 32px;
      font-weight: 500;
      text-align: center;
      margin-bottom: 32px;
    }
    .header{
      font-weight: 500;
      color: #3A3B3C;
      border-bottom: 1px solid #eee;
      margin-bottom: 32px;
      line-height: 40px;
      .version{
         margin-bottom: 12px;
      }
      .updateTime{
         margin-bottom: 12px;
      }
      .effectiveTime{
         margin-bottom: 40px;
      }
    }
    .content{
      font-size: 24px;
      color: #3A3B3C;
      line-height: 48px;
      .section{
        margin: 24px 0 16px 0;
        line-height: 48px;
        font-size: 28px;
        font-weight: 500;
      }
      .text{
        font-size: 24px;
        font-weight: 400;
      }
    }
  }
  </style>
